<template>
  <div class="col-sm-12 pl-3 pr-3">
    <div v-if="tableItems.length > 0" class="col-sm-12" :class="{'list-content' : !hideBorders}" style="overflow-x: hidden">
      <div class="col-12 p-2">
        <div
          v-for="(item, index) in materialSummaries"
          :key="index"
          class="row nopads pt-1"
        >
          <div class="col nopads pl-1 item-detail-title">
            {{ item.material.name }}
          </div>
          <div class="col nopads pl-1 item-detail-text">
            {{ item.station }}
          </div>
          <div class="col nopads pl-1 item-detail-text">
            {{ item.amount ? item.amount.toFixed(2) : "-" }} {{ item.unit }}
          </div>
        </div>
      </div>
      <vue3-datatable
          v-if="tableItems && tableItems.length > 0"
          :rows="tableItems"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="60vh"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="emitEdit"
      >
          <template #status="data">
                <span :class="statusClass(data.value.status)">
                    {{ getStatusString(data.value.status) }}
                </span>
          </template>
          <template #date="data">
              {{ data.value.date ? toLocalTime(data.value.date) : "-" }}
          </template>
      </vue3-datatable>
    </div>
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {deliveryNoteHelper} from "@/components/mixins/DeliveryNoteMixin";
import {deliveryStatus} from "@/components/mixins/DeliveryNoteMixin";
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: "DeliveryNoteList",
    components: {Vue3Datatable},
    mixins: [timeUtils, deliveryNoteHelper],
    props: {
        notes: {
            type: Array,
            default() {
                return []
            }
        },
        station: {
            type: Number
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        hideBorders: {
            type: Boolean,
            default: false
        },
        disableEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fields: [
                {
                    field: 'id',
                    title: this.$t('common.id'),
                    sort: true,
                    headerClass: 'routa-table-header',
                    type: 'number'
                },
                {
                    field: 'date',
                    title: this.$t('delivery_note.date'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'contract',
                    title: this.$t('delivery_note.contract'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'order',
                    title: this.$t('delivery_note.order'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'vehicle',
                    title: this.$t('delivery_note.vehicle'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'company',
                    title: this.$t('common.company'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'material',
                    title: this.$t('delivery_note.material'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'amount',
                    title: this.$t('delivery_note.amount'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'station',
                    title: this.$t('delivery_note.station'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'status',
                    title: this.$t('delivery_note.status'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'work_distance',
                    title: this.$t('daily_summary.work_distance'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'resettle_distance',
                    title: this.$t('daily_summary.resettle_distance'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
            ],
            tableItems: [],
            materialSummaries: []
        }
    },
    watch: {
        notes: function () {
            this.initTableItems()
            this.initSummaries()
        }
    },
    mounted: function () {
        this.initTableItems()
        this.initSummaries()
    },
    methods: {
        inDelivery(status) {
            return status === deliveryStatus.IN_DELIVERY
        },
        unloading(status) {
            return status === deliveryStatus.UNLOADING
        },
        getMaterialId(item) {
            return item.station_material ?
                'sta' + item.station_material.material.id :
                item.storage_material ? 'sto' + item.storage_material.id :
                    item.manually_added_material ? 'mm' + item.manually_added_material.id : undefined
        },
        getMaterialName(item) {
            return item.station_material ?
                item.station_material.material.name + " (" + (item.station_material.type_test_code) + ")" :
                item.storage_material ? item.storage_material.name :
                item.manually_added_material ? item.manually_added_material.material : ''
        },
        getStationName(item) {
            return item.station_material ?
                item.station_material.station.name :
                item.storage_material ? item.storage_material.storage.name : ''
        },
        getStationId(item) {
            return item.station_material ?
                item.station_material.station.id :
                item.storage_material ? item.storage_material.storage.id : ''
        },
        initTableItems: function () {
            this.tableItems = []
            const temp = []
            this.notes.forEach(item => {
                const wDist = this.getWorkDistance(item, item.amount, item.unit)
                const rDist = this.getResettleDistance(item, item.amount, item.unit)
                temp.push(
                    {
                        date: item.created,
                        contract: item.order.contract.name,
                        order: item.order.task_type.name,
                        vehicle: item.vehicle.license_plate,
                        company: item.vehicle.company.name,
                        material: this.getMaterialName(item),
                        amount: item.amount + " " + item.unit,
                        station: this.getStationName(item),
                        status: item.status,
                        stationId: this.getStationId(item),
                        id: item.id,
                        work_distance: wDist ? wDist.toFixed(2) : '',
                        resettle_distance: rDist ? rDist.toFixed(2) : ''
                    }
                )
            })
            this.$nextTick(() => this.tableItems = temp)
        },
        getWorkDistance: function (note, amount, unit) {
            let result = 0;
            if (note.trips && amount && unit) {
                note.trips.forEach(trip => {
                    if (trip.mode === 3 && trip.delivery_amount === amount && trip.delivery_unit === unit) {
                        result += trip.length
                    }
                })
            }
            return result;
        },
        getResettleDistance: function (note, amount, unit) {
            let result = 0;
            if (note.trips && amount && unit) {
                note.trips.forEach(trip => {
                    if (trip.mode === 1 && trip.delivery_amount === amount && trip.delivery_unit === unit) {
                        result += trip.length
                    }
                })
            }
            return result;
        },
        emitEdit: function (note) {
            if (this.isObserver && !this.disableEdit) {
                let item = this.notes.find(item => item.id === note.id)
                if (item) {
                    this.$emit('edit', item)
                }
            }
        },
        initSummaries() {
            this.materialSummaries = []
            this.notes.forEach(item => {
                let added = false
                this.materialSummaries.forEach(result => {
                    if (result.material.id === this.getMaterialId(item)) {
                        result.amount += item.amount
                        added = true
                    }
                })
                if (!added) {
                    this.materialSummaries.push({
                        material: {id: this.getMaterialId(item), name: this.getMaterialName(item)},
                        station: item.station_material ? item.station_material.station.name : item.storage_material ? item.storage_material.storage.name : "-",
                        amount: item.amount,
                        unit: item.unit
                    })
                }
            })
        },
        statusClass(statusCode) {
            switch (statusCode) {
                case deliveryStatus.LOADING:
                    return 'status-badge-rounded status-new'
                case deliveryStatus.IN_DELIVERY:
                    return 'status-badge-rounded status-assigned'
                case deliveryStatus.UNLOADING:
                    return 'status-badge-rounded status-in-progress'
                case deliveryStatus.UNLOADED:
                    return 'status-badge-rounded status-paid'
                default:
                    return 'status-badge-rounded status-default'
            }
        }
    }
}
</script>
<style scoped lang="scss">
.transport {
    color: #ffffff;
    background: #1F7F35;
    padding: .2em;
}

.unloading {
    color: #ffffff;
    background: #1E88E5;
    padding: .2em;
}

</style>
